import type { ReactNode } from 'react';
import { createMessagesContext } from '@talbenmoshe/prometheus-i18n-react';
import type { IMessages } from '@talbenmoshe/naru-i18n';

// One context for this app. Components read through these hooks and never build messages themselves.
export const { MessagesProvider, useMessages, useLocale, useLocaleSwitcher } = createMessagesContext<IMessages<ReactNode>>();
